import axios from 'axios'

export const axiosObj = (options?: any) => {
  const API_BASE_URL = String(process.env.REACT_APP_MOFF_API_URL)
  let axiosObj
  if (options.jwtToken) {
    axiosObj = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        Authorization: options.jwtToken,
      },
    })
  } else {
    axiosObj = axios.create({
      baseURL: API_BASE_URL,
    })
  }
  return axiosObj
}



// WEBPACK FOOTER //
// ./src/services/api.service.tsx